import moment from "moment";

const MONTHS_AGO_STR = (n) =>
  moment.utc().startOf("month").subtract(n, "months").format("YYYY/MM/DD");
const DAY_OF_MONTH = (d) => moment.utc().startOf("day").date(d);

const maritimeMonthlyValues = {
  [MONTHS_AGO_STR(0)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD_SHIPPING",
            countSent: 28,
          },
          {
            templateName: "NEWUSER_SHIPPING",
            countSent: 2,
          },
          {
            templateName: "NEWUSER_MANAGER",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(2),
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(3),
      },
      {
        notifications: [
          {
            templateName: "REPORT_MIDMONTHLY_SHIPPING",
            countSent: 12,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 3,
          },
        ],
        day: DAY_OF_MONTH(8),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(10),
      },
      {
        notifications: [
          {
            templateName: "NEWUSER_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(11),
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(12),
      },
    ],
  },
  [MONTHS_AGO_STR(1)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD_SHIPPING",
            countSent: 56,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(2),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(3),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 3,
          },
        ],
        day: DAY_OF_MONTH(4),
      },
      {
        notifications: [
          {
            templateName: "REPORT_MIDMONTHLY_SHIPPING",
            countSent: 12,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(16),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(18),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(20),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(25),
      },
    ],
  },
  [MONTHS_AGO_STR(2)]: {
    calendar: [
      {
        notifications: [
          {
            templateName: "REPORT_END_PERIOD_SHIPPING",
            countSent: 56,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
          {
            templateName: "NEWUSER_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(2),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(3),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(6),
      },
      {
        notifications: [
          {
            templateName: "REPORT_MIDMONTHLY_SHIPPING",
            countSent: 12,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(7),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(16),
      },
      {
        notifications: [
          {
            templateName: "NEWUSER_SHIPPING",
            countSent: 2,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 3,
          },
        ],
        day: DAY_OF_MONTH(19),
      },
      {
        notifications: [
          {
            templateName: "REPORT_KICKOFF_SHIPPING",
            countSent: 2,
          },
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(20),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 1,
          },
        ],
        day: DAY_OF_MONTH(25),
      },
      {
        notifications: [
          {
            templateName: "MILESTONES_SHIPPING",
            countSent: 2,
          },
        ],
        day: DAY_OF_MONTH(29),
      },
    ],
  },
};

export const getCalendarNotificationsPerTemplatePerDayMaritime = (
  teamId,
  startDate,
) => {
  //dates older than 2 months ago get '2 months ago'
  const keyDate = moment.max(
    moment.utc(startDate).startOf("month"),
    moment.utc().startOf("month").subtract(2, "months"),
  );
  const key = moment.utc(keyDate).format("YYYY/MM/DD");

  const data = maritimeMonthlyValues[key];
  return data;
};
